var map = {
	"./Cards.svg": "LS8w",
	"./add-document.svg": "lk3r",
	"./admin.svg": "BlLF",
	"./alipay.svg": "3DrL",
	"./bankCard1.svg": "QS+5",
	"./bankCard10.svg": "HQlR",
	"./bankCard2.svg": "rPQ3",
	"./bankCard3.svg": "bN0V",
	"./bankCard4.svg": "wcUp",
	"./bankCard5.svg": "+oWS",
	"./bankCard6.svg": "IxtB",
	"./bankCard7.svg": "89I0",
	"./bankCard8.svg": "K1Om",
	"./bankCard9.svg": "G+Rq",
	"./bar.svg": "BUXY",
	"./box-open.svg": "AyPJ",
	"./cangku.svg": "DbF2",
	"./cangkuliebiao.svg": "xD2u",
	"./cangkushenhe.svg": "Ds93",
	"./closeWifi.svg": "WAZr",
	"./cms-subject.svg": "zjZS",
	"./cms-topic.svg": "2SiQ",
	"./cms.svg": "fHET",
	"./code.svg": "IX5Q",
	"./coins.svg": "Kxms",
	"./company.svg": "znPN",
	"./creditValue.svg": "KkfT",
	"./creditValueList.svg": "YL2m",
	"./dashboard.svg": "BCGP",
	"./dingdan-copy.svg": "6U4W",
	"./document.svg": "mDNq",
	"./example.svg": "OOLB",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./fa-box.svg": "H+39",
	"./fa-boxes.svg": "Fxnc",
	"./fa-calendar-check.svg": "o7TC",
	"./fa-cart-shopping.svg": "OaIn",
	"./fa-check-circle.svg": "CJ45",
	"./fa-exclamation-triangle.svg": "b7lo",
	"./fa-gears.svg": "Zhod",
	"./fa-house.svg": "OWBf",
	"./fa-palette.svg": "PJQI",
	"./fa-pound-sign.svg": "d54h",
	"./fa-th-list.svg": "apkK",
	"./fa-user-tie.svg": "Azs1",
	"./fa-users.svg": "+CNl",
	"./fa-warehouse.svg": "OwQR",
	"./fa-wrench.svg": "Dr7G",
	"./fa_box.svg": "eKrp",
	"./fa_boxes.svg": "xoQ+",
	"./fa_circle-pound-sterling.svg": "z8X2",
	"./fa_contact.svg": "teRW",
	"./fa_credit-card.svg": "1gcn",
	"./fa_file-pen.svg": "AuOp",
	"./fa_fund.svg": "nFQh",
	"./fa_heart-handshake.svg": "iUEy",
	"./fa_home.svg": "V/Cg",
	"./fa_house.svg": "5CtI",
	"./fa_order.svg": "yGlC",
	"./fa_package.svg": "ABtJ",
	"./fa_plus.svg": "pAh2",
	"./fa_product.svg": "PRuN",
	"./fa_receipt-cent.svg": "PFkm",
	"./fa_receipt-pound-sterling.svg": "M+SG",
	"./fa_scroll.svg": "vowb",
	"./fa_shopping-bag.svg": "htNp",
	"./fa_user-cog.svg": "zi8X",
	"./fa_users.svg": "M7b1",
	"./fa_wallet.svg": "du+t",
	"./fa_warehouse.svg": "+Q8Y",
	"./fi-br-link-alt.svg": "14Tq",
	"./fi-bs-circle-user.svg": "xmwS",
	"./fi-bs-grid.svg": "OG+y",
	"./fi-bs-menu-dots.svg": "JAx8",
	"./fi-sr-assessment-alt.svg": "Etk5",
	"./fi-sr-assessment.svg": "z/EU",
	"./fi-sr-boxes.svg": "8C/L",
	"./fi-sr-cart-shopping-fast.svg": "aJyj",
	"./fi-sr-category.svg": "3oPG",
	"./fi-sr-coins.svg": "IgA2",
	"./fi-sr-credit-card.svg": "dcnr",
	"./fi-sr-envelope.svg": "RT3P",
	"./fi-sr-file-invoice-dollar.svg": "bAGY",
	"./fi-sr-gears.svg": "rBLO",
	"./fi-sr-hand-holding-heart.svg": "v4tr",
	"./fi-sr-headset.svg": "1D3C",
	"./fi-sr-home.svg": "DSw7",
	"./fi-sr-id-badge.svg": "uP+O",
	"./fi-sr-id-card-clip-alt.svg": "rNZb",
	"./fi-sr-list-dropdown.svg": "Vu/Y",
	"./fi-sr-seller.svg": "+b5e",
	"./fi-sr-settings.svg": "UcoU",
	"./fi-sr-undo.svg": "ftbR",
	"./fi-sr-user-gear.svg": "qwVe",
	"./fi-sr-users-alt.svg": "nLrf",
	"./fi-sr-warehouse-alt.svg": "rQLg",
	"./fi-ss-bell.svg": "fy7f",
	"./fi-ss-hand-holding-usd.svg": "EU67",
	"./fi-ss-receipt.svg": "enZw",
	"./fi-ss-seller-store.svg": "/xiO",
	"./fi-ss-user-check.svg": "uj0C",
	"./fi-ss-user-pen.svg": "5B1z",
	"./fi-ss-user-salary.svg": "/+5M",
	"./file-edit.svg": "UArW",
	"./file-invoice-dollar.svg": "ocXq",
	"./frame.svg": "IPab",
	"./headset.svg": "Q2fc",
	"./home.svg": "U9Ws",
	"./huobi.svg": "PyRl",
	"./isCheck.svg": "cBjV",
	"./jiesuanzhouqi.svg": "zfKT",
	"./line-file-pound.svg": "aUWz",
	"./line.svg": "9xjd",
	"./link.svg": "KgwQ",
	"./list-dropdown.svg": "jDJD",
	"./login-mall.svg": "xzZT",
	"./lunbotu.svg": "Oz9N",
	"./menu.svg": "dH9r",
	"./menu/circularWarehouse.svg": "sHAJ",
	"./menu/dashboard.svg": "Yw9x",
	"./menu/form.svg": "qFrK",
	"./menu/marker.svg": "yWeb",
	"./menu/order.svg": "52vv",
	"./menu/poundSymbol.svg": "OAYK",
	"./menu/securityLock.svg": "FNoq",
	"./menu/settingsOption.svg": "ap4v",
	"./menu/shoppingBag.svg": "GST1",
	"./menu/userIcon.svg": "h5ic",
	"./menu/warehouse.svg": "ff2J",
	"./message.svg": "G2zY",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./orderClose.svg": "1ME1",
	"./orderComplete.svg": "4iq6",
	"./orderPedding.svg": "2WRl",
	"./password.svg": "QjmH",
	"./pound.svg": "UYMC",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./question-check.svg": "c9SP",
	"./restock.svg": "J3aG",
	"./review.svg": "3epJ",
	"./shangpinshenhe.svg": "6sSM",
	"./shenpi.svg": "ATbL",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./spec.svg": "TfIM",
	"./table.svg": "oSYw",
	"./team-check-alt.svg": "6nmI",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./undo-alt.svg": "+tKh",
	"./undo.svg": "0twP",
	"./user-gear.svg": "toFX",
	"./user.svg": "VdD3",
	"./users-alt.svg": "yKzI",
	"./video.svg": "3JNx",
	"./warehouse-alt.svg": "0sfK",
	"./wechat.svg": "pYJ+",
	"./yanpiaoduizhang.svg": "aEi5",
	"./yonghuliebiao.svg": "pbe1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eZ11";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg \.svg$
// module id = eZ11
// module chunks = 63